import { OptionType } from '@evinced-private/ui-common';

import { naturalSort } from 'src/common/helpers/DataFilterHelper';

interface IScanGroupsRawResult {
	scan_groups?: Array<{ scan_id?: string | null; scan_name_any?: string | null } | null> | null;
}

interface IAllScanNamesRawResult {
	all_scan_names?: Array<{ scan_id?: string | null; scan_name?: string | null } | null> | null;
}

const toSortedScanOptions = <T extends { scan_id?: string | null }>(
	items: Array<T | null> | null | undefined,
	getLabel: (item: T) => string | null | undefined
): OptionType[] =>
	(items ?? [])
		.filter((item): item is T => item != null && Boolean(item.scan_id) && Boolean(getLabel(item)))
		.map((item) => ({ value: item.scan_id as string, label: getLabel(item) as string }))
		.toSorted((a, b) => naturalSort(a.label, b.label));

export const transformScanGroups = (rawResults: IScanGroupsRawResult): OptionType[] =>
	toSortedScanOptions(rawResults?.scan_groups, (g) => g.scan_name_any);

export const transformAllScanNames = (rawResults: IAllScanNamesRawResult): OptionType[] =>
	toSortedScanOptions(rawResults?.all_scan_names, (r) => r.scan_name);
